
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8.5","r":"8","fill":"#0E8B1B"}}),_c('path',{attrs:{"d":"M12.223 5.342a.79.79 0 00-.543.24l-4.705 4.704-2.073-2.073a.79.79 0 10-1.116 1.116l2.631 2.632a.79.79 0 001.117 0l5.263-5.263a.789.789 0 00-.574-1.356z","fill":"#fff"}})])
          )
        }
      }
    